import t from "@ext/localization/locale/translate";
import PropertyColor from "@ext/properties/models/PropertyColor";
import { ColorTile } from "@ui-kit/ColorTile";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";

interface PropertyStylePickerProps {
	value?: PropertyColor;
	/** `null` means "no style": clicking the selected tile clears it (gh#912). */
	onChange?: (color: PropertyColor | null) => void;
}

export const PropertyStylePicker = ({ value, onChange }: PropertyStylePickerProps) => {
	return (
		<div className="grid grid-flow-col grid-rows-2 gap-1 p-1.5" data-testid="color-tile-picker">
			{Object.values(PropertyColor).map((color) => (
				<div
					className="[&>div:first-of-type]:border-inverse-muted"
					data-testid={`color-tile-picker-item-${color}`}
					key={color}
				>
					<Tooltip>
						<TooltipTrigger asChild>
							<ColorTile
								className="border-alpha-high-90"
								key={color}
								onClick={() => onChange?.(value === color ? null : color)}
								selected={value === color}
								style={{ background: `var(--color-property-bg-${color})` }}
							/>
						</TooltipTrigger>
						<TooltipContent>{t(`properties.colors.${color}`)}</TooltipContent>
					</Tooltip>
				</div>
			))}
		</div>
	);
};
